import { Row, Col, Image } from "antd";
import { useEffect } from "react";

export const TrinityBadminton = () => {
  useEffect(() => {
    const scriptSrc = "https://www.instagram.com/embed.js";
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      document.body.appendChild(script);
      return;
    }

    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, []);

  const imageStyle = {
    width: "100%",
    height: "auto",
  };

  const captionStyle = {
    textAlign: "center",
    marginTop: "8px",
  };

  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="trinity-badminton">
          Building Futures: Nahil Wijesuriya's Gift to Trinity College's Next
          Generation
        </h1>
      </div>
      <Row>
        <Col xs={24} sm={24} md={24}>
          <p>
            For more than half a century, <strong>Nahil Wijesuriya</strong> has
            remained steadfast in his belief that success carries with it a
            responsibility to give back. Throughout his life, his philanthropy
            has been guided by a simple principle: invest in institutions that
            shape young people, and the impact will be felt for generations.
          </p>
          <p>
            His latest contribution to <strong>Trinity College Kandy</strong>,
            a <strong>Rs. 100 million</strong> donation towards the construction
            of a state-of-the-art Badminton Court Complex at Asgiriya Stadium,
            is another expression of that philosophy.
          </p>
          <p>
            The new facility represents far more than a sporting venue. It
            removes one of the greatest obstacles faced by Trinity's badminton
            programme and provides future generations of students with the
            opportunity to train, compete and develop in an environment designed
            for excellence.
          </p>
          <p>
            Badminton has been part of Trinity's sporting tradition since it
            became an official college sport in 1977. Despite producing talented
            players and achieving success at national level, the programme
            operated for decades without a dedicated on-campus training
            facility. Players travelled to external venues where limited court
            availability often restricted practice time and constrained coaching
            opportunities.
          </p>
          <p>
            Recognising this longstanding need, Nahil Wijesuriya stepped
            forward with a <strong>Rs. 100 million</strong> contribution to fund
            the construction of a modern badminton complex within the historic
            Asgiriya Stadium.
          </p>
          <p>
            The facility now provides Trinity's young shuttlers with a
            permanent home, allowing structured training programmes, greater
            coaching flexibility and significantly improved preparation for
            competition. More importantly, it gives future students
            opportunities that previous generations simply did not have.
          </p>
          <p>
            For Nahil, this project is deeply personal.
          </p>
          <p>
            Having attended Trinity College between 1954 and 1964, he has often
            described the school as one of the greatest influences on his life.
            Over the decades he has supported numerous initiatives at the
            college, including the Old Trinitians Sports Club, sporting
            facilities and educational infrastructure. His commitment reflects
            his enduring gratitude to the institution that helped shape his
            values and character.
          </p>
          <p>
            The Badminton Court Complex joins a growing legacy of educational
            philanthropy that extends well beyond Trinity. In recent years,
            Nahil has contributed towards transformative projects including the
            Little Hearts Project at Lady Ridgeway Hospital, Bishop's College,
            Ananda College and S. Thomas' College, each driven by the belief
            that investment in education and opportunity creates lasting social
            impact.
          </p>
          <p>
            The significance of the Trinity project lies not only in the
            building itself, but in what it represents.
          </p>
          <p>
            Every student who walks onto the courts in the years ahead will
            benefit from an opportunity created by someone who once stood where
            they stand today. It is a reminder that the strongest institutions
            are built not only through tradition, but through alumni who choose
            to invest in their future.
          </p>
          <p>
            As Trinity's badminton programme enters a new era, the facility
            will undoubtedly contribute to stronger performances and new
            sporting achievements. Yet its greatest legacy may be less visible:
            inspiring future generations to believe that success is measured not
            only by what we achieve ourselves, but by what we enable others to
            achieve.
          </p>
          <p>
            That philosophy has defined Nahil Wijesuriya's lifelong commitment
            to philanthropy, and it is a legacy that will continue to shape
            Trinity College for decades to come.
          </p>
          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            <Col xs={24} lg={12}>
              <div style={{ maxWidth: "500px", margin: "0 auto" }}>
                <iframe
                  src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ftck.badminton%2Fposts%2Fpfbid0yP1Sgus2E8GVUCkHpxNurovuMDRCFFDG5YQr7hhzF7bjwuBwa2fn9QsM6VtTBDg9l&show_text=true&width=500"
                  width="500"
                  height="792"
                  style={{
                    border: "none",
                    overflow: "hidden",
                    maxWidth: "100%",
                  }}
                  scrolling="no"
                  frameBorder="0"
                  allowFullScreen
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  title="Trinity College Kandy Badminton Facebook post"
                ></iframe>
              </div>
            </Col>
            <Col xs={24} lg={12}>
              <div style={{ maxWidth: "540px", margin: "0 auto" }}>
                <blockquote
                  className="instagram-media"
                  data-instgrm-captioned
                  data-instgrm-permalink="https://www.instagram.com/reel/DYEqP8emiYF/?utm_source=ig_embed&utm_campaign=loading"
                  data-instgrm-version="14"
                  style={{
                    background: "#FFF",
                    border: 0,
                    borderRadius: "3px",
                    boxShadow:
                      "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
                    margin: "1px",
                    maxWidth: "540px",
                    minWidth: "326px",
                    padding: 0,
                    width: "calc(100% - 2px)",
                  }}
                >
                  <div style={{ padding: "16px" }}>
                    <a
                      href="https://www.instagram.com/reel/DYEqP8emiYF/?utm_source=ig_embed&utm_campaign=loading"
                      style={{
                        background: "#FFFFFF",
                        lineHeight: 0,
                        padding: 0,
                        textAlign: "center",
                        textDecoration: "none",
                        width: "100%",
                      }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      View this post on Instagram
                    </a>
                    <p
                      style={{
                        color: "#c9c8cd",
                        fontFamily: "Arial,sans-serif",
                        fontSize: "14px",
                        lineHeight: "17px",
                        marginBottom: 0,
                        marginTop: "8px",
                        overflow: "hidden",
                        padding: "8px 0 7px",
                        textAlign: "center",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <a
                        href="https://www.instagram.com/reel/DYEqP8emiYF/?utm_source=ig_embed&utm_campaign=loading"
                        style={{
                          color: "#c9c8cd",
                          fontFamily: "Arial,sans-serif",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "normal",
                          lineHeight: "17px",
                          textDecoration: "none",
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        A post shared by Badminton - Trinity College Kandy
                        (@trinity_badminton)
                      </a>
                    </p>
                  </div>
                </blockquote>
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            <Col xs={24} md={12}>
              <Image
                style={imageStyle}
                src={
                  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/74-Trinity-Badminton/trinity-college-kandy-badminton-facility-2025-1-1170x611.jpg.webp"
                }
              />
              <div style={captionStyle}>
                <p>
                  <small>Trinity College Kandy Badminton Facility</small>
                </p>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <Image
                style={imageStyle}
                src={
                  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/74-Trinity-Badminton/nahil-wijesuriya-award-badminton.jpg"
                }
              />
              <div style={captionStyle}>
                <p>
                  <small>Nahil Wijesuriya Award</small>
                </p>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <Image
                style={imageStyle}
                src={
                  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/74-Trinity-Badminton/nahil-wijesuriya-cutting-ribbon.jpg"
                }
              />
              <div style={captionStyle}>
                <p>
                  <small>Nahil Wijesuriya Cutting Ribbon</small>
                </p>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <Image
                style={imageStyle}
                src={
                  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/74-Trinity-Badminton/nahil-wijesuriya-plaque.jpg"
                }
              />
              <div style={captionStyle}>
                <p>
                  <small>Nahil Wijesuriya Plaque</small>
                </p>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};